import request from './AxiosRequest';

const addComment = data =>
	request({
		url: `/Services/MainService.svc/json/SaveComment`,
		method: 'POST',
		data
	});

const deleteComment = commentId =>
	request({
		url: '/Services/MainService.svc/json/SaveComment',
		method: 'POST',
		data: {
			comment: {
				Action: 2,
				CommentId: commentId
			}
		}
	});

const SaveComment = {
	add: addComment,
	delete: deleteComment
}

export default SaveComment;
